/**
 * @fileoverview Handler para tratar exceções específicas da API
 * @module ApiExceptionHandler
 */

/**
 * Função que trata erros específicos do processo de login
 * @function loginErrorHandler
 * @param {Error} error - Objeto de erro retornado pela API
 * @param {Function} setMessage - Função para definir mensagem de erro no estado
 * @returns {void}
 * 
 * @example
 * loginErrorHandler(error, setMessage);
 */

/**
 * @typedef {Object} MessageConfig
 * @property {boolean} open - Define se a mensagem deve ser exibida
 * @property {string} vertical - Posição vertical da mensagem
 * @property {string} horizontal - Posição horizontal da mensagem
 * @property {string} severity - Severidade da mensagem (error, warning, info, success)
 * @property {number} duration - Duração da mensagem em milissegundos
 * @property {string} curvature - Curvatura do componente de mensagem
 * @property {string} variant - Variante visual da mensagem
 * @property {string} text - Texto da mensagem
 */

/**
 *
 * @param {Error} error erro na resposta da api.
 * @param {React.Dispatch<React.SetStateAction<object>>} setMessage define mensagem para o toast
 */
export function loginErrorHandler(error, setMessage) {
     //console.error(Object.entries(error))

    // network error
    if (error && error.hasOwnProperty('response') && error.response === undefined) {
        setMessage({
            open: true,
            vertical: 'top',
            horizontal: 'center',
            severity: 'error',
            duration: 5000,
            curvature: '24px',
            variant: 'default',
            text: 'Erro de rede ou servidor indisponível.'
        });
    }

    if (error && error.hasOwnProperty('response') && error.response !== undefined) {
        const { status } = error.response;
        switch(status) {
            case 400:
                setMessage({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    severity: 'error',
                    duration: 5000,
                    curvature: '24px',
                    variant: 'standard',
                    text: 'Erro e-mail ou senha inválidos.'
                });
                return;
                case 401:
                setMessage({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    severity: 'error',
                    duration: 5000,
                    curvature: '24px',
                    variant: 'standard',
                    text: 'Erro e-mail ou senha inválidos.'
                });
                return;
                case 403:
                setMessage({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    severity: 'error',
                    duration: 5000,
                    curvature: '24px',
                    variant: 'error',
                    text: 'Erro e-mail ou senha inválidos.'
                });
                return;
            case 404:
                setMessage({
                    open: true,
                    vertical: 'top',
                    horizontal: 'center',
                    severity: 'error',
                    duration: 5000,
                    curvature: '24px',
                    variant: 'standard',
                    text: 'Erro Recurso não encontrado.'
                });
                return;
            default:
                break;
        }
    }
}
